<div class="card">
  <div class="card-body admin-model-height formbg-d2">
    <sms-headAdmin></sms-headAdmin>
    <dual-list [sort]="keepSorted" [source]="source" [key]="key" [display]="display" [filter]="filter"
      [TitleTab]="TitlePage" [SourceSideValue]="SourceSideValue" [DestinationSideValue]="DestinationSideValue"
      [(destination)]="confirmed" (destinationChange)="OnChange($event)" [format]="format" [disabled]="disabled">
    </dual-list>

  </div>
</div>